module.exports = __webpack_public_path__ + "media/images/pdfPlaceholder-14ebfcfd.png";